/* CRAZY — script unique, chargé en defer. Menu, panier (AJAX), page produit. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const T = window.czT || {};
  const verrou = (on) => { document.documentElement.style.overflow = on ? 'hidden' : ''; };
  const post = (url, corps) => fetch(racine + url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(corps)
  });

  /* ---------- Menu latéral ---------- */
  const menu = $('[data-cz-menu]');
  if (menu) {
    const burger = $('[data-cz-ouvre-menu]');
    const bascule = (o) => {
      menu.hidden = !o;
      if (burger) burger.setAttribute('aria-expanded', o);
      verrou(o);
      if (o) { const x = $('.cz-croix', menu); if (x) x.focus(); }
    };
    if (burger) burger.addEventListener('click', () => bascule(true));
    menu.addEventListener('click', (e) => { if (e.target.closest('[data-cz-ferme-menu]')) bascule(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) bascule(false); });
  }

  /* ---------- Panier ---------- */
  const panier = $('[data-cz-panier]');
  const pagePanier = $('[data-cz-panier-page]');
  const majCompteur = (n) => $$('[data-cz-compteur]').forEach((el) => { el.textContent = n; el.hidden = !n; });
  const poser = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const neuf = $('[data-cz-contenu]', doc);
    if (!neuf) return;
    $$('[data-cz-corps]').forEach((c) => { c.innerHTML = ''; c.appendChild(neuf.cloneNode(true)); });
    majCompteur(Number(neuf.dataset.czNombre || 0));
  };
  const rafraichir = async () => {
    const r = await fetch(racine + '?section_id=crazy-panier-contenu', { headers: { Accept: 'text/html' } });
    if (r.ok) poser(await r.text());
  };
  const charge = (on) => $$('[data-cz-panier], [data-cz-panier-page]').forEach((z) => z.classList.toggle('est-charge', on));
  const ouvrir = () => {
    if (pagePanier) return;
    if (!panier) { location.href = racine + 'cart'; return; }
    panier.hidden = false;
    verrou(true);
    const x = $('.cz-croix', panier);
    if (x) x.focus();
  };
  const fermer = () => { if (panier && !panier.hidden) { panier.hidden = true; verrou(false); } };
  const action = async (fn) => {
    charge(true);
    try { await fn(); await rafraichir(); } catch (_) {}
    charge(false);
  };

  document.addEventListener('click', (e) => {
    const c = e.target;
    if (c.closest('[data-cz-ouvre-panier]')) {
      if (pagePanier) return;
      e.preventDefault();
      rafraichir();
      ouvrir();
      return;
    }
    if (c.closest('[data-cz-ferme-panier]')) fermer();
    const maj = c.closest('[data-cz-maj]');
    if (maj) {
      action(() => post('cart/change.js', { id: maj.dataset.czCle, quantity: Number(maj.dataset.czMaj) }));
      return;
    }
    const passe = c.closest('[data-cz-passe]');
    if (passe) {
      const u = {};
      u[passe.dataset.de] = 0;
      u[passe.dataset.vers] = 1;
      action(() => post('cart/update.js', { updates: u }));
      return;
    }
    const aj = c.closest('[data-cz-ajoute]');
    if (aj) {
      action(() => post('cart/add.js', { items: [{ id: Number(aj.dataset.czAjoute), quantity: 1 }] }));
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') fermer(); });

  /* Ajout au panier sans rechargement (fiche produit, cartes, kit) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-cz-form]');
    if (!form) return;
    e.preventDefault();
    const btns = $$('[data-cz-ajout]');
    const btn = $('[type="submit"]', form);
    const lab = $('[data-cz-btn-txt]', form) || btn;
    const avant = lab.textContent;
    if (btn) btn.disabled = true;
    lab.textContent = T.ajout || '…';
    try {
      const fd = new FormData(form);
      fd.append('sections', 'crazy-panier-contenu');
      const r = await fetch(racine + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || '');
      if (d.sections && d.sections['crazy-panier-contenu']) poser(d.sections['crazy-panier-contenu']);
      else await rafraichir();
      lab.textContent = T.ajoute || '✓';
      if (pagePanier) location.reload(); else ouvrir();
    } catch (err) {
      lab.textContent = err.message || T.erreur || '!';
    }
    setTimeout(() => { lab.textContent = avant; if (btn) btn.disabled = false; }, 1400);
    void btns;
  });

  /* ---------- Page produit ---------- */
  const pp = $('[data-cz-produit]');
  if (pp) {
    const piste = $('[data-cz-piste]', pp);
    const vues = $$('[data-cz-vue]', pp);
    const vig = $$('[data-cz-vignette]', pp);
    let idx = 0;
    const marquer = (i) => { idx = i; vig.forEach((v, k) => v.classList.toggle('est-actif', k === i)); };
    const aller = (i) => {
      if (!vues.length || !piste) return;
      i = (i + vues.length) % vues.length;
      piste.scrollTo({ left: i * piste.clientWidth, behavior: 'smooth' });
      marquer(i);
    };
    vig.forEach((v, i) => v.addEventListener('click', () => aller(i)));
    $$('[data-cz-fleche]', pp).forEach((f) => f.addEventListener('click', () => aller(idx + (f.dataset.czFleche === 'd' ? 1 : -1))));
    if (piste) {
      let t;
      piste.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => { const i = Math.round(piste.scrollLeft / piste.clientWidth); if (i !== idx) marquer(i); }, 80);
      }, { passive: true });
    }

    const form = $('form[data-cz-form]', pp);
    const prix = $('[data-cz-prix]', pp);
    const barre = $('[data-cz-barre]', pp);
    const eco = $('[data-cz-eco]', pp);
    const qte = $('[data-cz-qte-champ]', pp);
    const maj = (pousser) => {
      const c = $('input[name="id"]:checked', pp);
      if (!c) return;
      const d = c.dataset;
      const n = qte ? Math.max(1, parseInt(qte.value, 10) || 1) : 1;
      if (prix) prix.textContent = d.prix;
      if (barre) { barre.textContent = d.barre || ''; barre.hidden = !d.barre; }
      if (eco) { eco.textContent = d.eco || ''; eco.hidden = !d.eco; }
      $$('[data-cz-btn-prix]').forEach((el) => { el.textContent = n === 1 ? ' · ' + d.prix : ''; });
      $$('[data-cz-sticky-nom]').forEach((el) => { el.textContent = d.nom; });
      $$('[data-cz-sticky-prix]').forEach((el) => { el.textContent = d.prix; });
      if (pousser) {
        const u = new URL(location.href);
        u.searchParams.set('variant', c.value);
        history.replaceState({}, '', u);
      }
    };
    pp.addEventListener('change', (e) => { if (e.target.name === 'id') maj(true); else if (e.target === qte) maj(false); });
    $$('[data-cz-qte]', pp).forEach((b) => b.addEventListener('click', () => {
      qte.value = Math.max(1, (parseInt(qte.value, 10) || 1) + (b.dataset.czQte === '+' ? 1 : -1));
      maj(false);
    }));
    maj(false);

    const sticky = $('[data-cz-sticky]');
    const bouton = $('[data-cz-ajout]', pp);
    if (sticky && bouton && 'IntersectionObserver' in window) {
      new IntersectionObserver((es) => es.forEach((en) => {
        sticky.classList.toggle('est-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      })).observe(bouton);
      const sb = $('[data-cz-sticky-btn]', sticky);
      if (sb && form) sb.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    }

    const rb = $('[data-cz-rebours]', pp);
    if (rb) {
      const tic = () => {
        const n = new Date();
        const f = new Date();
        f.setHours(Number(rb.dataset.heure || 20), 0, 0, 0);
        const m = Math.floor((f - n) / 60000);
        const boite = rb.closest('[data-cz-envoi]');
        if (m <= 0) { if (boite) boite.hidden = true; return; }
        rb.textContent = (T.encore || '%t%').replace('%t%', Math.floor(m / 60) + ' h ' + String(m % 60).padStart(2, '0') + ' min');
      };
      tic();
      setInterval(tic, 30000);
    }
  }
})();